// useUserData.ts
import { useState, useEffect } from 'react';
import { useUserQuery } from '../graphql/types-and-hooks';

/**
 * Custom hook to provide user data and login status
 */
export const useUserData = () => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const { data, loading, error } = useUserQuery({
    variables: {}
  });

  useEffect(() => {
    if (!loading) {
      if (data?.user) {
        setUser(data.user);
        setIsLoggedIn(true);
      } else {
        setUser(null);
        setIsLoggedIn(false);
      }
    }
  }, [data, loading, error]);

  return {
    user,
    isLoggedIn,
    loading
  };
};

export default useUserData;